import { lotteryService } from '@/api/services/lottery.service';

export const state = () => ({
    dataList: [],
    data: null,
    status: false
});

export const getters = {
    dataList(state) {
        return state.dataList;
    }
};

export const actions = {
    acRegisterExternalLottery({ dispatch, commit }, formData) {
        commit('registerRequest', formData);
        return lotteryService.registerExternalLottery(formData).then(
            (data) => {
                dispatch('notification/success', 'Tạo từ file thành công', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    acUpdateExternalLotteryFile({ dispatch, commit }, { id, formData }) {
        commit('registerRequest', formData);
        return lotteryService.updateExternalLotteryFile(id, formData).then(
            (data) => {
                dispatch('notification/success', 'Cập nhật file thành công', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    acGetExternalImportStatus({ dispatch }, { lotteryId, importId }) {
        return lotteryService.getExternalImportStatus(lotteryId, importId).then(
            (data) => data,
            (error) => {
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    acGetExternalDataColumns({ dispatch }, id) {
        return lotteryService.getExternalDataColumns(id).then(
            (data) => data,
            (error) => {
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    listLottery({ dispatch, commit }, query) {
        commit('listRequest', []);
        return lotteryService.listLottery(query).then(
            (data) => data,
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    detailLottery({ dispatch, commit }, id) {
        commit('listRequest', []);
        return lotteryService.detailLottery(id).then(
            (data) => {
                commit('listSuccess', data.data);
                return data.data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    registerLottery({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return lotteryService.registerLottery(data).then(
            (data) => {
                dispatch('notification/success', '登録しました', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    updateLottery({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return lotteryService.updateLottery(data).then(
            (data) => {
                dispatch('notification/success', '更新しました', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    deleteLottery({ dispatch, commit }, id) {
        commit('deleteRequest', id);
        return lotteryService.deleteLottery(id).then(
            (data) => {
                dispatch('notification/success', '削除しました', { root: true });
                commit('deleteSuccess', data.data);
                return data;
            },
            (error) => {
                commit('deleteFailure', error);
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    settingLottery({ dispatch, commit }, payload) {
        commit('registerRequest', payload);
        return lotteryService.settingLottery(payload).then(
            (data) => {
                dispatch('notification/success', '設定しました', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    candidatesPreview({ dispatch }, payload) {
        return lotteryService.candidatesPreview(payload).then(
            (data) => data,
            (error) => {
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    exportCandidates({ dispatch }, payload) {
        return lotteryService.exportCandidates(payload).then(
            (data) => data,
            (error) => {
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    drawLottery({ dispatch, commit }, payload) {
        return lotteryService.drawLottery(payload).then(
            (data) => data,
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    drawStatus({ dispatch }, payload) {
        return lotteryService.drawStatus(payload).then(
            (data) => data,
            (error) => {
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    listWinners({ dispatch }, payload) {
        return lotteryService.listWinners(payload).then(
            (data) => data,
            (error) => {
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    addWinner({ dispatch }, payload) {
        return lotteryService.addWinner(payload).then(
            (data) => {
                if (!data?.code || data.code === 200 || data.code === 201) {
                    dispatch('notification/success', '作成しました', { root: true });
                } else {
                    dispatch('notification/error', data, { root: true });
                }
                return data;
            },
            (error) => {
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    updateWinner({ dispatch }, payload) {
        return lotteryService.updateWinner(payload).then(
            (data) => {
                if (!data?.code || data.code === 200 || data.code === 201) {
                    dispatch('notification/success', '更新しました', { root: true });
                } else {
                    dispatch('notification/error', data, { root: true });
                }
                return data;
            },
            (error) => {
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    deleteWinner({ dispatch }, payload) {
        return lotteryService.deleteWinner(payload).then(
            (data) => {
                if (!data?.code || data.code === 200 || data.code === 204) {
                    dispatch('notification/success', '削除しました', { root: true });
                } else {
                    dispatch('notification/error', data, { root: true });
                }
                return data;
            },
            (error) => {
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    },

    exportWinners({ dispatch }, payload) {
        return lotteryService.exportWinners(payload).then(
            (data) => data,
            (error) => {
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    }
};

export const mutations = {
    registerRequest(state, data) {
        state.status = false;
        state.data = data;
    },
    registerSuccess(state, data) {
        state.status = true;
        state.data = data;
    },
    registerFailure(state) {
        state.status = {};
        state.data = null;
    },
    listRequest(state, data) {
        state.status = false;
        state.dataList = data;
    },
    listSuccess(state, data) {
        state.status = true;
        state.dataList = data;
    },
    listFailure(state) {
        state.status = {};
        state.dataList = [];
    },
    deleteRequest(state, data) {
        state.status = false;
        state.data = data;
    },
    deleteSuccess(state, data) {
        state.status = true;
        state.data = data;
    },
    deleteFailure(state) {
        state.status = {};
        state.data = null;
    }
};
